import { Injectable } from '@angular/core';
import { EventData } from '@app-shared/services/event-class';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class EventBusService {
    private subject$ = new Subject<EventData>();
    constructor() {}
    emit(event: EventData) {
        this.subject$.next(event);
    }
    on(eventName: String, action: any): Subscription {
        return this.subject$.pipe(
            filter((e: EventData) => e.name === eventName),
            map((e: EventData) => e.value)
        ).subscribe(action);
    }
}